import { ILookupResult, IMenuItem, ISearchMenuItem } from '../types';

export function collectMatches(
  collector: ISearchMenuItem[],
  searchText: string,
  menuItem: IMenuItem
): ISearchMenuItem[] {
  if (!searchText) {return collector;}
  const caption = ((menuItem || {}).caption || '').toLowerCase();
  const index = !menuItem.actionUrl ? -1 : caption.indexOf(searchText);
  if (index >= 0) {
    collector.push({ index, caption: menuItem.caption, menuItem });
  }
  collector = matchReducer(collector, menuItem.menuItems, searchText);
  return collector;
}

export function matchReducer(
  collector: ISearchMenuItem[],
  arrayOfItems: IMenuItem[],
  searchText: string
): ISearchMenuItem[] {
  return arrayOfItems.reduce(
    (a: ISearchMenuItem[], c: IMenuItem) => collectMatches(a, searchText, c),
    collector
  );
}

export function matchComparer(a: any, b: any): number {
  const diff = a.index - b.index;
  if (diff !== 0) {return diff;}
  if (a.caption < b.caption) {return -1;}
  if (a.caption > b.caption) {return 1;}
  return 0;
}

export function searchMenuItemToLookupResult(item: ISearchMenuItem): ILookupResult {
  const menuItem = item.menuItem;
  const additionalClasses = {
    ['sip-modal']: !!menuItem?.modal,
    ['sip-link']: !!menuItem.actionUrl,
  };
  return {
    label: item.caption,
    href: item.menuItem.actionUrl,
    additionalClasses,
    target: '_self',
    shortcut: '',
    modal: !!menuItem?.modal,
  };
}

export default function searchMenuItems(
  searchText: string,
  menuItems: IMenuItem[]
): ILookupResult[] {
  return matchReducer([], menuItems, searchText.toLowerCase())
    .sort(matchComparer)
    .map(searchMenuItemToLookupResult);
}
